import type { ReactNode } from "react";
import { Link } from "react-router-dom";

type FooterProps = {
  /** Quiet copy before the action (e.g. "Don't have an account?"). */
  lead?: ReactNode;
  children: ReactNode;
};

/** One quiet action under a hairline, at the foot of the card. */
export function AuthCardFooter({ lead, children }: FooterProps) {
  return (
    <div className="mt-7 border-t border-hairline pt-4.5 text-center text-sm leading-4.5 text-ink-quiet">
      {lead ? <>{lead} </> : null}
      {children}
    </div>
  );
}

const ACTION_CLASS =
  "rounded-control text-ink-faint transition-colors duration-150 hover:text-ink focus-visible:outline-offset-4";

type ActionProps = {
  children: ReactNode;
} & (
  | { to: string; href?: never; onClick?: never }
  | { href: string; to?: never; onClick?: never }
  | { onClick: () => void; to?: never; href?: never }
);

/** The action inside `AuthCardFooter`: an in-app route, an external href, or a button. */
export function AuthFooterAction({ children, to, href, onClick }: ActionProps) {
  if (to !== undefined) {
    return (
      <Link to={to} className={ACTION_CLASS}>
        {children}
      </Link>
    );
  }
  if (href !== undefined) {
    return (
      <a href={href} className={ACTION_CLASS}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className={ACTION_CLASS}>
      {children}
    </button>
  );
}
